import {Component, OnInit} from '@angular/core';
import {UserService} from '../../../service/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {User} from '../../../model/user.model';
import {ConfigService} from '../../../service/config.service';
import {Keys, StorageService} from '../../../service/storage.service';
import {LoanApplicationInteractor} from '../../../interactors/loan-application.interactor';
import {MatDialog, MatDialogConfig} from '@angular/material';
import {AddFundPopupV2Component} from '../../../shared/add-fund-popup-v2/add-fund-popup-v2.component';
import {PaymentCollectionService} from '../../../service/payment-collection.service';
import {
    PaymentCollectionResponseByProfileIdForTable,
    PaymentProduct
} from '../../../model/payment/PaymentCollectionRequest';
import {PreApprovedLoanManualCreditAssessment} from '../../../model/eligibility-check/pre-approved-loan-manual-credit-assessment.model';
import {LoanApplicationSource} from '../../../model/loan-application/loan-application-source.model';
import {
    MultipleLoanEligibilityCheck, MultipleLoanEligibilityRule
} from '../../../model/eligibility-check/multiple-loan-eligibility-check.model';
import moment = require('moment');

export interface PreApprovedLoanOfferCard {
    image: string;
    header: string;
    description;
}
@Component({
    selector: 'app-all-loans-and-applications',
    templateUrl: './all-loans-and-applications.component.html',
    styleUrls: ['./all-loans-and-applications.component.scss']
})
export class AllLoansAndApplicationsComponent implements OnInit {
    private readonly configService: ConfigService;
    private readonly router: Router;
    private readonly storageService: StorageService;
    user: User;
    canReapplyForLoan = false;
    outstandingEligibilityCheck: MultipleLoanEligibilityCheck;
    preApprovedLoanOffer: PreApprovedLoanManualCreditAssessment;
    preApprovedLoanOfferCard: PreApprovedLoanOfferCard;
    private readonly matDialog: MatDialog;

    // Transaction table properties
    userTransactions: Array<PaymentCollectionResponseByProfileIdForTable>;
    tableHeader = ['DATE', 'TIME', 'TRANSFER STATUS', 'AMOUNT PAID', 'PAYMENT METHOD', 'TRANSACTION ID'];
    displayedColumns: string[] = ['createdAt', 'time', 'status', 'amount', 'paymentMode', 'transactionId'];

    minimumLoanAmount: number;
    loanAmountDenomination: number;

    constructor(private userService: UserService,
        private activatedRoute: ActivatedRoute,
        private loanApplicationInteractor: LoanApplicationInteractor,
        configService: ConfigService,
        router: Router,
        storageService: StorageService,
        matDialog: MatDialog,
        private paymentCollectionService: PaymentCollectionService
    ) {
        this.configService = configService;
        this.router = router;
        this.storageService = storageService;
        this.matDialog = matDialog;
    }

    async ngOnInit(): Promise<void> {
        this.minimumLoanAmount = this.configService.getPreApprovedLoanOfferMinimumLoanAmount();
        this.loanAmountDenomination = this.configService.getPreApprovedLoanAmountDenomination();
        this.activatedRoute.data.subscribe(async data => {
            await this.onDataResolved(data);
        });
    }

    async onDataResolved(data): Promise<void> {
        this.user = new User(data.userId);
        this.getUserPaymentTransactions(data.userId);
        this.user = await this.userService.getProfileDetails(data.userId);
        if (this.configService.isMultipleLoanApplyEnabled()) {
            await this.fetchPreApprovedLoanOffer(data.userId);
            this.canReapplyForLoan = await this.loanApplicationInteractor.canReapplyForLoan(data.userId);
        }

    }

    navigateToLoanInfo() {
        this.removeLoanApplicationFromLocalStorage();
        this.router.navigate(['/borrow/loan-info']);
    }

    removeLoanApplicationFromLocalStorage() {
        this.storageService.removeItem(Keys.LOAN_APPLICATION);
    }

    payYourEmiHandler() {
        const matDialogConfig: MatDialogConfig = {
            maxHeight: '90vh',
            width: '80%',
            panelClass: 'dialog-responsive',
            data: {
                dialogHeading: `Make Your Payments`,
                dialogSubHeading: `You can pay EMIs or Part/Full Prepay your loan <br> Part prepayments should be in multiples of <strong style="color: #000;">₹1000 </strong>`,
                bodyNotifySupportEmail: `Please notify us at <a href="mailto:support@finzy.com" target="_blank">support@finzy.com</a>`,
                bodyNormalContent: `If you have multiple loans and you are transferring EMIs or making prepayment in one transfer and
                                    if you want to apply the funds transferred to certain specific loan(s) as soon as you complete the transfer`,
                bodyTitle: `You can pay your EMI by choosing an online payment method`,
                bodyEnterAmount: `Enter Amount:`,
                payButtonText: `PAY NOW`,
                amountWarningText: `Please enter the valid amount`,
                tableHeading: `You can pay your EMI by <span style="font-weight: bolder;">transferring funds</span>to this bank`,
                paymentProduct: PaymentProduct.LOAN_EMI_PAYMENT,
                bankDetails: {
                    'Account Name': 'Bridge fintech solutions Pvt Ltd',
                    'Bank': 'ICICI Bank',
                    'Virtual Account Number': '2FINZYRAKS021818',
                    'Account type': 'Current account',
                    'IFSC code': 'ICIC0000104'
                },
                hideBankDetails: true
            }
        };
        this.matDialog.open(AddFundPopupV2Component, matDialogConfig).afterClosed().subscribe(response => {
            console.log(response);
        });
    }

    availPreApprovedLoanOffer() {
        this.router.navigate(['/borrow/dashboard/pre-approved-loan-offer']);
    }

    prePartyPayHandler() {
        const matDialogConfig: MatDialogConfig = {
            maxHeight: '90vh',
            width: '80%',
            panelClass: 'dialog-responsive',
            data: {
                dialogHeading: `Make Your Payments`,
                dialogSubHeading: `You can pay EMIs or Part/Full Prepay your loan <br> Part prepayments should be in multiples of <strong style="color: #000;">₹1000 </strong>`,
                bodyNotifySupportEmail: `Please notify us at <a href="mailto:support@finzy.com" target="_blank">support@finzy.com</a>`,
                bodyNormalContent: `If you have multiple loans and you are transferring EMIs or making prepayment in one transfer and
                                    if you want to apply the funds transferred to certain specific loan(s) as soon as you complete the transfer`,
                bodyTitle: `You can pay your EMI by choosing an online payment method`,
                bodyEnterAmount: `Enter Amount:`,
                payButtonText: `PAY NOW`,
                amountWarningText: `Please enter the valid amount`,
                tableHeading: `You can pay your EMI by <span style="font-weight: bolder;">transferring funds</span>to this bank`,
                paymentProduct: PaymentProduct.LOAN_EMI_PAYMENT,
                bankDetails: {
                    'Account Name': 'Bridge fintech solutions Pvt Ltd',
                    'Bank': 'ICICI Bank',
                    'Virtual Account Number': '2FINZYRAKS021818',
                    'Account type': 'Current account',
                    'IFSC code': 'ICIC0000104'
                },
                hideBankDetails: true
            }
        };
        this.matDialog.open(AddFundPopupV2Component, matDialogConfig).afterClosed().subscribe(response => {
            console.log(response);
        });
    }


    async getUserPaymentTransactions(userId: string) {
        try {
            const transactionList = await this.paymentCollectionService.getUserPaymentTransactions(userId);
            if (Array.isArray(transactionList)) {
                this.userTransactions = transactionList.map((val) => {
                    return ({
                        createdAt: moment(val.createdAt).format('D MMM YYYY'),
                        time: moment(val.createdAt).format('h:mm:ss'),
                        status: val.status,
                        amount: val.amount,
                        paymentMode: val.paymentMode,
                        transactionId: val.transactionId
                    });
                });
            }
        } catch (error) {
            console.log(error);
        }
    }

    private async fetchPreApprovedLoanOffer(userId: string): Promise<void> {
        const allPreApprovedLoanOffers = await this.loanApplicationInteractor.getAllPreApprovedLoanOffersForUser(userId);

        if (allPreApprovedLoanOffers && allPreApprovedLoanOffers.length > 0) {
            const eligibility = await this.loanApplicationInteractor.getMultipleLoanEligibilityForUser(userId, LoanApplicationSource.PRE_APPROVAL);
            const failedChecks = eligibility.checks.filter(check => !check.isValid);
            if (eligibility.isEligible || (failedChecks.length === 1 && failedChecks[0].rule === MultipleLoanEligibilityRule.OUTSTANDING_PRINCIPAL_LIMIT)) {
                this.outstandingEligibilityCheck = eligibility.checks.find(check => check.rule === MultipleLoanEligibilityRule.OUTSTANDING_PRINCIPAL_LIMIT);
                this.preApprovedLoanOffer = await this.loanApplicationInteractor.getActivePreApprovedLoanOfferForUser(userId);
                if (eligibility.isEligible) {
                    this.setPreApprovedLoanOfferCard('pre-approved-loan-offer.svg', 'Congratulations!', 'You have a pre- approved');
                } else {
                    this.setPreApprovedLoanOfferCard('thumbs-up.svg', 'WOW!!!', 'You seem to be making most of your');
                }
            } else {
                this.setPreApprovedLoanOfferCard('lock.svg', 'Sorry!', 'Currently you do not have access to');
            }
        }
    }

    private setPreApprovedLoanOfferCard(image: string, header: string, description: string): void {
        this.preApprovedLoanOfferCard = {
            image: image,
            header: header,
            description: description
        };
    }
}
